import Vue from 'vue'
import App from './app/App.vue'
import './app/App.css'
import './assets/css/style.css'

// VueJS Plugins
import './app/plugins/axios'
import './app/plugins/vuetify'

// App components
import router from './app/router'
import store from './app/store'

// App configuration
import './app/conf/sentry'

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
